import { useContext } from 'react';
import useIdentityContext from './useIdentityContext';
import { InternalViewContext } from '../components/contexts/InternalViewContext';

/*
 * If internal user, we set the shopper id to internal user context's shopper id else we set
 * it to identity's shopper id.
 */
export const useShopperId = (): string => {
  const internalViewContext = useContext(InternalViewContext);

  const { isIdentityInitialized, identity } = useIdentityContext();
  if (!isIdentityInitialized || !identity) {
    return '';
  }
  const { isInternalUser } = identity;
  const defaultShopperId = identity?.shopperId || '';

  if (internalViewContext && isInternalUser) {
    return internalViewContext?.internalViewerSuppliedShopperId || '';
  }

  return defaultShopperId;
};
